<div class="wrapper">
  <app-sidebar />
  <div class="color-line"></div>

  <app-topbar [title]="title" [subTitle]="subTitle"
    (mobileMenuButtonClicked)="onToggleMobileMenu()"
  />
  <div class="page-content">
    <div class="page-container">
      <router-outlet  (activate)="onActivate($event)"/>
    </div>
    <app-footer></app-footer>
  </div>
</div>
